export const positionChoices = [
    { label: '一般クラス', value: '一般クラス' },
    { label: '責任者クラス', value: '責任者クラス' },
    { label: 'リーダークラス', value: 'リーダークラス' },
    { label: '主任クラス', value: '主任クラス' },
    { label: 'その他', value: 'その他' },
]
